import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle, FaPhone, FaEnvelope, FaGlobe } from "react-icons/fa";
import "../Css/Profile.css";

const ProfileCard = () => {
    const [activeTab, setActiveTab] = useState("Timeline");
    const [userData, setUserData] = useState(null); // State to hold fetched user data
    const [isLoading, setIsLoading] = useState(true); // State for loading status
    const [error, setError] = useState(null); // State for error handling

    const navigate = useNavigate(); // Initialize navigate hook

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };


    const getCookie = (name) => {
        const cookieString = document.cookie;
        const cookies = cookieString.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null; // Return null if cookie not found
    };

    useEffect(() => {
        const fetchUserProfile = async () => {
            const useremail = getCookie('email');

            if (!useremail) {
                // User is not logged in
                alert("Please log in first.");
                navigate('/login'); // Redirect to your login route
                return; // Stop execution
            }

            // User is logged in, fetch data
            setIsLoading(true); // Start loading
            setError(null); // Reset error state

            try {
                // Replace with your actual API endpoint
                const response = await fetch(`https://ethiccraft.org/backend/profile/read_byEmail.php?email=${useremail}`, {
                    credentials: 'include'
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error("Error fetching profile by read_by_email:", response.statusText);
                    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setUserData(data); // Set fetched data to state
            } catch (err) {
                console.error("Error fetching user profile:", err);
                setError("Failed to load profile. Please log in again."); // Set error state
                // Optionally, you might want to redirect or show a more prominent error message
            } finally {
                setIsLoading(false); // End loading
            }
        };

        fetchUserProfile(); // Call the fetch function
    }, [navigate]); // Dependency array includes navigate to avoid lint warnings, though it won't change

    // Render loading state
    if (isLoading) {
        return <div className="profile-container">Loading profile...</div>;
    }

    // Render error state
    if (error) {
        return <div className="profile-container">Error: {error}</div>;
    }

    // Render the profile card once data is loaded
    // Use optional chaining (?.) or check if userData exists before accessing properties
    if (!userData) {
        // This case should theoretically not be reached if isLoading and error are handled,
        // but as a fallback
        return <div className="profile-container">No profile data available.</div>;
    }

    return (
        <div className="profile-container">
            {/* Left Section */}
            <div className="profile-left">
                <div className="profile-image-wrapper">
                    <img src={`https://ethiccraft.org/${userData.profile_image}` || "https://via.placeholder.com/150"} alt="Profile" className="profile-img" />
                    {console.log(userData.profile_image || "Rendering Error")};
                </div>
                <div className="profile-verification-status">
                    {userData.FacilitatorApproved === 1 || userData.FacilitatorApproved === true ? (
                        <span className="verified tooltip">
                            Verified <FaCheckCircle />
                        </span>
                    ) : (
                        <span className="not-verified tooltip">
                            <FaTimesCircle /> Profile Not Verified
                            <span className="tooltip-text">Contact the Ethiccraft Team for verification</span>
                        </span>
                    )}
                </div>
                <div className="profile-info">
                    <h2>{userData.full_name || "N/A"}</h2>
                    <p className="Graduation_department">{"Mentor Name : " + userData.Mentors_Name || "Mentor Name : N/A"}</p>
                </div>

                <div className="profile-actions">
                    <button className="btn33">
                        <a
                            href={userData.social_links ? "https://www.instagram.com/" + userData.social_links : "https://www.instagram.com/"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {"Instagram : " + (userData.social_links || "N/A")}
                        </a>
                    </button>

                    <button className="btn33">
                        <a
                            href={`mailto:${userData.email}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {userData.email ? `Gmail : ${userData.email}` : "Gmail : N/A"}
                        </a>
                    </button>
                </div>
            </div>

            {/* Right Section */}
            <div className="profile-right">
                <div className="profile-tabs">
                    <button className={`tab ${activeTab === "Timeline" ? "active" : ""}`} onClick={() => handleTabClick("Timeline")}>Timeline</button>
                    <button className={`tab ${activeTab === "About" ? "active" : ""}`} onClick={() => handleTabClick("About")}>About</button>
                </div>

                {activeTab === "Timeline" && (
                    <>
                        <div className="profile-section profile-card">
                            <h3>Contact Information</h3>

                            {userData.phone_number && (
                                <div className="info-block">
                                    <strong><FaPhone className="info-icon" /> Phone: </strong>
                                    <span>{userData.phone_number}</span>
                                </div>
                            )}

                            {userData.email && (
                                <div className="info-block">
                                    <strong><FaEnvelope className="info-icon" /> Email: </strong>
                                    <span>{userData.email}</span>
                                </div>
                            )}

                            {userData.address && (
                                <div className="info-block">
                                    <strong><FaGlobe className="info-icon" /> Address: </strong>
                                    <span>{userData.address}</span>
                                </div>
                            )}
                        </div>

                        <div className="profile-section profile-card">
                            <h3>Study Information</h3>
                            {/* Use user data for basic info */}
                            {userData.dob && (
                                <>
                                    <div className="info-block">
                                        <strong>Course :</strong> {userData.department || "N/A"}
                                    </div>
                                    <div className="info-block">
                                        <strong>University:</strong> {userData.college || "N/A"}
                                    </div>
                                    <div className="info-block">
                                        <strong>Graduation Year:</strong> {userData.year_of_study || "N/A"}
                                    </div>
                                </>
                            )}
                            {!userData.dob && <p>No basic information available.</p>}
                        </div>
                    </>
                )}

                {activeTab === "About" && (
                    <>
                        <div className="profile-section profile-card">
                            <h3>About {userData.full_name || "User"}</h3> {/* Use user name */}
                            {/* Use user data for about section */}
                            {userData.bio && (
                                <div>
                                    {/* Assuming about is a string, split by newlines for paragraphs */}
                                    {userData.bio.split('\n').map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))}
                                </div>
                            )}
                            {!userData.bio && <p>No about information available.</p>}
                        </div>

                        <div className="profile-skills profile-card">
                            <h3>Skills</h3>
                            {userData.skills && userData.skills.length > 0 ? (
                                <div className="skills-list">
                                    {userData.skills}
                                </div>
                            ) : (
                                <p>No skills listed.</p>
                            )}
                        </div>

                        <div className="profile-section profile-card">
                            <h3>Basic Information</h3>
                            {/* Use user data for basic info */}
                            {userData.dob && (
                                <>
                                    <div className="info-block">
                                        <strong>Birthday:</strong> {userData.dob || "N/A"}
                                    </div>
                                    <div className="info-block">
                                        <strong>Gender:</strong> {userData.gender || "N/A"}
                                    </div>
                                    <div className="info-block">
                                        <strong>Blood-Group:</strong> {userData.blood_group || "N/A"}
                                    </div>
                                </>
                            )}
                            {!userData.dob && <p>No basic information available.</p>}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProfileCard;